import { Component, OnInit } from '@angular/core'
import { Mission } from '../../../common/interfaces/mission.interface'
import { FormGroup, Validators, FormBuilder } from '@angular/forms'
import { BreadcrumbService } from '../../../common/services/breadcrumb.service'
import { Router } from '@angular/router'
import { OfflineResourceService } from '../../../common/services/offline/offline-resource.service'

@Component({
  selector: 'app-sample-pre-create',
  templateUrl: './sample-pre-create.component.html',
  styleUrls: ['./sample-pre-create.component.scss']
})
export class SamplePreCreateComponent implements OnInit {
  missions: Mission[]

  form: FormGroup = this.formBuilder.group({
    missionId: [null, Validators.required]
  })

  constructor(
    breadcrumbService: BreadcrumbService,
    private offlineResourceService: OfflineResourceService,
    private formBuilder: FormBuilder,
    private router: Router
  ) {
    breadcrumbService.breadcrumbLinks.next([
      {
        label: 'Nouveau prélèvement'
      }
    ])
  }

  ngOnInit() {
    this.offlineResourceService.getMissions().then(
      (res: Mission[]) => {
        this.missions = res
      }
    )
  }

  createSample(form: FormGroup): void {
    this.router.navigate([
      '/missions',
      form.value.missionId,
      'samples',
      'create'
    ])
  }
}
